import { render } from "./SmartMatch.vue?vue&type=template&id=cb7effca"
import script from "./SmartMatch.vue?vue&type=script&lang=js"
export * from "./SmartMatch.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__